/**
 * Compact summary of a scenario selection for chip display.
 *   0 selected → ''
 *   1 selected → code
 *   2–3       → comma-joined codes
 *   ≥ 4        → "{n} selected"
 */
export function formatScenarioSelection(selected: readonly string[]): string {
  if (selected.length === 0) return ''
  if (selected.length === 1) return selected[0] ?? ''
  if (selected.length <= 3) return selected.join(', ')
  return `${selected.length} selected`
}
